export type GetDeploymentRequestsResponse = {
  deploymentRequestList: DeploymentRequest[];
};

export type DeploymentRequest = {
  deploymentRequestListNo: string;
  dplymntReqSeq: string;
  jediPjtId: string;
  dplymntSts: string;
  dplymntStsTypeName: string;
  dplymntResultKbn: string;
  dplymntResultKbnName: string;
  dplymntType: string;
  dplymntTypeName: string;
  dplymntEnv: string;
  envId: string;
  reqUser: string;
  reqDtime: string;
  scheDtime: string;
  dplymntAprvr: string;
  aprvrDtime: string;
  rvwCmnt: string;
  retryCnt: number;
  errorInfo: string;
  dplymntCmpDtime: string;
  reverttargetdplymntReqSeq: string;
  screenMode: string;
  updateDtimeTDplymntReqMng: string;
  cmpdplymntReqtDetail: CmpdplymntReqtDetail[];
};

export type CmpdplymntReqtDetail = {
  cmpId: string;
  cmpprjProtocol: string;
  cmpprjChgTyp: string;
  cmpprjName: string;
  cmpprjRootcmpId: string;
  cmpprjDip: string;
  cmpprjScheDtime: string;
  cmpprjRelatedIfdPrjName: string;
  cmpprjRelatedIfdScheDtime: string;
  updateDtimeTDplyReqMng: string;
  tckId: string;
  cmpdplymntAttribute: cmpdplymntAttribute[];
};

type cmpdplymntAttribute = {
  attributeKey: string;
  activeValue: string;
  currentValue: string;
};
